// Hiển thị CHỈ ĐỌC bối cảnh/thời đại (đợt 260804).
// Mặc định của cả hai màn là XEM, không phải khai: AI tự đánh giá và điền, người chỉ sửa khi thấy sai.
import React from 'react';
import { Descriptions, Tag } from 'antd';
import type { WorldSetting } from '../../types/film';

const ROWS_VI: Record<string, string> = {
  era: 'Thời đại & văn hoá', world: 'Bối cảnh', architecture: 'Kiến trúc & vật liệu', costume: 'Trang phục',
};

const ROWS: [keyof WorldSetting, string][] = [
  ['era', 'Era & culture'],
  ['world', 'Setting'],
  ['architecture', 'Architecture & materials'],
  ['costume', 'Costume vocabulary'],
];

/** `compact`: nhãn tiếng Việt + cột nhãn hẹp (trang tổng quan truyện, Film mode). Mặc định giữ nguyên bản cũ. */
const WorldSettingView: React.FC<{ value: WorldSetting | null; compact?: boolean }> = ({ value, compact }) => (
  <Descriptions size="small" column={1} bordered styles={compact ? { label: { width: 168 } } : undefined}>
    {ROWS.filter(([k]) => value?.[k]).map(([k, label]) => (
      <Descriptions.Item key={String(k)} label={compact ? ROWS_VI[String(k)] ?? label : label}>{value?.[k] as string}</Descriptions.Item>
    ))}
    {value?.forbidden?.length ? (
      <Descriptions.Item label={compact ? 'Cấm' : 'Forbidden'}>
        {value.forbidden.map((f, i) => <Tag key={i} color="red">{f}</Tag>)}
      </Descriptions.Item>
    ) : null}
  </Descriptions>
);

export default WorldSettingView;
